import {
  ADD_USER_ACCOUNT_BEGIN,
  KEY_FOR_USER_NAME,
  KEY_FOR_USER_EMAIL,
  KEY_FOR_DESIGNATION,
  TOGGLE_SHOW_SUBMIT_ADD_USER_RESULT,
  ADD_USER_ACCOUNT_SUCCESS,
  ADD_USER_ACCOUNT_FAILURE, KEY_FOR_PASSWORD,
} from './constants';
import http from '../../../common/http';
import { apiEndPoints } from '../../../common/globalConstants';
import { toast } from 'react-toastify';

export function addNewAccount(userAccount) {
  return dispatch => {
    dispatch({
      type: ADD_USER_ACCOUNT_BEGIN,
    });
    const url = `${apiEndPoints.userManagement.ADD_USER}`;
    const promise = new Promise((resolve, reject) => {
      const formData = new FormData();
      formData.append(KEY_FOR_USER_NAME, userAccount.name);
      formData.append(KEY_FOR_USER_EMAIL, userAccount.email);
      formData.append(KEY_FOR_PASSWORD,userAccount.password);
      formData.append(KEY_FOR_DESIGNATION, userAccount.designation);
      const doRequest = http.post(url, formData);
      doRequest.then(
        res => {
          dispatch({
            type: ADD_USER_ACCOUNT_SUCCESS,
            data: { ...userAccount, ...res.data.data },
          });
          resolve(res);
        },
        err => {
          toast.error('User has not been created');
          dispatch({
            type: ADD_USER_ACCOUNT_FAILURE,
          });
          reject(err);
        },
      );
    });
    return promise;
  };
}

export const toggleShowSubmitAddUserResult = isShowSubmitAddUserResult => {
  return dispatch => {
    dispatch({
      type: TOGGLE_SHOW_SUBMIT_ADD_USER_RESULT,
      data: isShowSubmitAddUserResult,
    });
  };
};

export function reducer(state, action) {
  switch (action.type) {
    case ADD_USER_ACCOUNT_BEGIN:
      return {
        ...state,
        addNewAccountBegin: true,
        addNewAccountFailure: false,
        addNewAccountSuccess: false,
      };
    case ADD_USER_ACCOUNT_SUCCESS:
      return {
        ...state,
        addNewAccountBegin: false,
        addNewAccountFailure: false,
        addNewAccountSuccess: true,
        accounts: [...state.accounts, { ...action.data }],
        isShowSubmitAddUserResult: true,
      };
    case ADD_USER_ACCOUNT_FAILURE:
      return {
        ...state,
        addNewAccountBegin: false,
        addNewAccountFailure: true,
        addNewAccountSuccess: false,
      };
    case TOGGLE_SHOW_SUBMIT_ADD_USER_RESULT:
      return {
        ...state,
        isShowSubmitAddUserResult: action.data,
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/user-management/redux/addNewAccount.js